import useGTM from "./useGTM";

export type { UseGTMProps } from "./useGTM.d";
export default useGTM;
